import React from 'react';

import { useOfferContext } from '../../Offer';

function Fee({ value }: { value: string }) {
  const { i18n } = useOfferContext();

  return (
    <span className="Offer-fee" data-testid="offer-fee">
      {i18n.t('offers.includes_fee', { fee: value })}
    </span>
  );
}

Fee.displayName = 'Fee';

export { Fee };
